import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import { STATUS_CANCELED } from '../commons/utils';

const ReservationsList = props => (
  <Container fluid className="reservations-list__container no-padding">
    {
      Object.values(props.reservationsList).map((reservation) => {
        const { status, id } = reservation;

        const reservationKey = `RESERVATION[${id}]`;

        if (status === STATUS_CANCELED && !props.showCancelledReservations) return <React.Fragment key={reservationKey} />;

        return (
          React.Children.map(props.children, child => React.cloneElement(child, {
            key: reservationKey,
            reservation: reservation
          }))
        )
      }).reverse()
    }
  </Container>
);

ReservationsList.propTypes = {
  reservationsList: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  showCancelledReservations: PropTypes.bool
};

ReservationsList.defaultProps = {
  reservationsList: {},
  children: [],
  showCancelledReservations: false
};

export default ReservationsList;
